module.exports = __webpack_public_path__ + "img/resumeman.819949ad.svg";